module.exports = __webpack_public_path__ + "mobile/img/icon_user_nav_4.5ad6c6e6.png";